// extracted by mini-css-extract-plugin
module.exports = {"container":"Tools_container__tqF1r","direction":"Tools_direction__2MDUC","animationControls":"Tools_animationControls__WCLmc","animationImage":"Tools_animationImage__1HmEQ"};